import React from 'react';
import { Navigate, Route, Routes } from "react-router-dom";
import '../App.css';
import { WebCache } from "../services/WebCache";
import AutomaticDebit from "./automaticdebit/AutomaticDebit";
import CreditFlow from "./creditflow/CreditFlow";
// import CaratGateway from "./caratgateway/CaratGateway"; // comentado: aun no esta listo
import GenerateQR from './charges/GenerateQR';
import TransfersReturnReport from "./charges/TransfersReturnReport";
import DataCommerce from './commerce/DataCommerce';
import LoyaltyVirtualCoupons from "./coupons/LoyaltyVirtualCoupons";
import Dashboard from "./Dashboard";
import GlobalLoader from "./GlobalLoader";
import HelpComponent from './help/HelpComponent';
import HelpIncidentComponent from './help/HelpIncidentComponent';
import Footer from './layout/Footer';
import Header from "./layout/Header";
import HelpSidebar from './layout/help/HelpSidebar';
import { LayoutProvider } from './layout/LayoutContext';
import MenuITD from "./layout/menu/Menu";
import ClientReport from "./loyalty/clients/ClientReport";
import LoyaltyPromotions from "./loyalty/clients/LoyaltyPromotions";
import Loyalty from "./loyalty/Loyalty";
import LoyaltyAccountReport from "./loyalty/LoyaltyAccountReport";
import MercadoPagoPage from './mercadopago/MercadoPagoPage';
import MercadoPagoPageConfirm from './mercadopago/MercadoPagoPageConfirm';
import ConciliationDashboard from "./payments/ConciliationDashboard";
import OperationTableReport from "./payments/OperationTableReport";
import PaymentCalendar from "./payments/PaymentCalendar";
import PaymentReport from "./payments/PaymentReport";
import PaymentTaxReport from "./payments/PaymentTaxReport";
import PaymentTransactionReport from "./payments/PaymentTransactionReport";
import PresentationDownloadsReport from './payments/PresentationDownloadsReport';
import PresentationReport from "./payments/PresentationReport";
import SendProfileManagement from "./SendProfileManagement";
import SettlementChargeBacks from './settlements/SettlementChargeBacks';
import SettlementConf from './settlements/SettlementConf';
import SettlementsByDay from './settlements/SettlementsByDay';
import SettlementsByMonth from './settlements/SettlementsByMonth';
import BranchManagement from "./terminals/BranchManagement";
import TaxDocumentation from './terminals/FiscalDocumentInvoices';
import QrPctInvoicesDocumentation from "./terminals/QrPctInvoiceInvoices";
import TerminalMap from "./terminals/TerminalMap";
import TerminalsReport from './terminals/TerminalsReport';
import CurrentTransactionReport from "./transactions/CurrentTransactionReport";
import TransactionReport from "./transactions/TransactionReport";
import UsersManagement from './UsersManagement';
import AdvancedRefund from './advanced/AdvancedRefund';
import HistoricAdvanced from './advanced/HistoricAdvanced';
import RetailTransactions from './transactions/RetailTransactions';
import {MessagesProvider} from "./MessagesContext";
import { UtilService } from '../services/UtilService';
import CookieBanner from './CookiesBanner';
import RollsRequest from './terminals/RollsRequest';

interface IProps {
}

const Home: React.FC<IProps> = (props) => {
    const isValid = true;
    return (
        <React.Fragment>
            <GlobalLoader></GlobalLoader>
        <div className={`page${WebCache.isPosnetAppUser() ? ' isPosnetAppUser' : ''}`}>
            <div className="page-main">
                <MessagesProvider>
                    <LayoutProvider>
                        {/* //si es usuario posnet app ocultas */}
                        {
                            !WebCache.isPosnetAppUser() &&
                                <>
                                    <Header></Header>
                                </>
                        }
                        <div style={{paddingLeft:"0px",backgroundColor:"#F4F4F4"}}>
                            <div  style={{ display: 'flex', height: '100%'}}>
                                {
                                    !WebCache.isPosnetAppUser() && 
                                        <MenuITD></MenuITD> 
                                }
                                {/* //si es usuario posnet app ocultas */}
                                <HelpSidebar></HelpSidebar>
                                {UtilService.isMobilePlatform() || WebCache.isPosnetAppUser() ? <></> : <CookieBanner />}
                                <Routes>
                                    <Route path={'/'} element={<Navigate to={'/dashboard'} />} />
                                    <Route path={'/help'} element={<HelpComponent />} />
                                    <Route path={'/help/incident'} element={<HelpIncidentComponent />} />
                                    <Route path={'/dashboard'}
                                        element={
                                            (!WebCache.isUserConciliator()) && WebCache.isDashboardAllowed() ? (
                                                <Dashboard />
                                            ) : (
                                                <Navigate
                                                    to="/sales/transactions"
                                                />
                                            )
                                        }
                                    />
                                    {/* Transacciones */}
                                    <Route path={'/sales/transactions'} element={WebCache.isTransactionsAllowed() || WebCache.isPosnetAppUser() ? (
                                        <TransactionReport />
                                    ) : (
                                        <Navigate
                                            to="/help/session"
                                        />
                                    )} />
                                    <Route path={'/sales/minTransactions'} element={(WebCache.isTransactionsAllowed() && !WebCache.isUserUYU() && WebCache.getAllWholesalerMerchants(false).length>0) ? (// si contiene comercios asociados y es de argentina, estara disponible esta seccion
                                        <RetailTransactions />
                                    ) : (
                                        <Navigate
                                            to="/help/session"
                                        />
                                    )} />
                                    <Route path={'/sales/pendingOrders'} element={WebCache.isTransactionsAllowed() ? (
                                        <CurrentTransactionReport />
                                    ) : (
                                        <Navigate
                                            to="/help/session"
                                        />
                                    )} />
                                    {/* QR */} 
                                    {UtilService.isMobilePlatform()? "" :
                                    <>
                                    <Route path={'/charge/transfersReturn'} element={WebCache.isDevelopmentQrAllowed() ? (
                                        <TransfersReturnReport />
                                    ) : (
                                        <Navigate
                                            to="/help/session"
                                        />
                                    )} /> 
                                    <Route path={'/charge/generateQR'} element={WebCache.isManagementAllowed() ? (
                                        <GenerateQR />
                                    ) : (
                                        <Navigate
                                            to="/charge/transfersReturn"
                                        />
                                    )} />
                                    <Route path={'/charge/automaticDebit'} element={WebCache.isDaAllowed() ? (
                                        <AutomaticDebit />
                                    ) : (
                                        <Navigate
                                            to="/dashboard"
                                        />
                                    )} />
                                    <Route path={'/charge/creditflow'} element={!WebCache.isUserUYU() ? (
                                        <CreditFlow />
                                    ) : (
                                        <Navigate to="/dashboard" />
                                    )} />
                                    {/* comentado: CaratGateway aun no esta listo
                                    <Route path={'/integrations/caratgateway'} element={WebCache.getCaratGatewayUrl() !== "" && WebCache.getCaratGatewayUrl() != null ? (
                                        <CaratGateway />
                                    ) : (
                                        <Navigate
                                            to="/dashboard"
                                        />
                                    )} /> */}
                                    </>
                                    }
                                    {/* Advanced */}
                                    <Route path={'/advanced/search'} element={(WebCache.isAdvancedAllowed() && WebCache.isUserARG()) ? (
                                        <AdvancedRefund />
                                    ) : (
                                        <Navigate
                                            to="/dashboard"
                                        />
                                    )} />
                                    <Route path={'/advanced/historic'} element={(WebCache.isAdvancedAllowed() && WebCache.isUserARG()) ? (
                                        <HistoricAdvanced />
                                    ) : (
                                        <Navigate
                                            to="/dashboard"
                                        />
                                    )} />
                                    {/* Terminals */}
                                    {UtilService.isMobilePlatform() ? "" :
                                    <>
                                    <Route path={'/terminals/branches'} element={WebCache.isManagementAllowed() ? (
                                        <BranchManagement />
                                    ) : (
                                        <Navigate
                                            to="/dashboard"
                                        />
                                    )} />
                                    <Route path={'/terminals/map'} element={WebCache.isManagementAllowed() ? (
                                        <TerminalMap />
                                    ) : (
                                        <Navigate
                                            to="/dashboard"
                                        />
                                    )} />
                                    <Route path={'/terminals/reports'} element={<TerminalsReport allowUpdateTerminal={false} />} />
                                    <Route path={'/terminals/management'} element={WebCache.isManagementAllowed() ? (
                                        <TerminalsReport allowUpdateTerminal={true} />
                                    ) : (
                                        <Navigate
                                            to="/dashboard"
                                        />
                                    )} />
                                    <Route path={'/terminals/rolls'} element={(WebCache.isManagementAllowed() && WebCache.isUserARG()) ? (
                                        <RollsRequest />
                                    ) : (
                                        <Navigate
                                            to="/dashboard"
                                        />
                                    )} />
                                    </>}
                                    <Route path={'/terminals/fiscalDocumentInvoices'} element={WebCache.isManagementAllowed() || WebCache.isFinancialAllowed() ? (
                                        <TaxDocumentation/>
                                    ) : (
                                        <Navigate
                                            to="/dashboard"
                                        />
                                    )} />
                                    <Route path={'/terminals/qrPctInvoices'} element={(WebCache.isUserARG() && (WebCache.isManagementAllowed() || WebCache.isFinancialAllowed())) ? (
                                        <QrPctInvoicesDocumentation/>
                                    ) : (
                                        <Navigate
                                            to="/dashboard"
                                            />                                    
                                    )} />   
                                    {/* Conciliation */}
                                    <Route path={'/conciliation/dashboard'} element={ (!WebCache.isUserConciliator()) && WebCache.isFinancialAllowed() ? (
                                        <ConciliationDashboard />
                                    ): (
                                        <Navigate
                                            to="/dashboard"
                                            />                                    
                                    )} />                                 
                                    <Route path={'/conciliation/calendar'}
                                        element={
                                            WebCache.isFinancialAllowed() || WebCache.isPosnetAppUser() ? (
                                                <PaymentCalendar />
                                            ) : (
                                                <Navigate
                                                    to="/sales/transactions"
                                                />
                                            )
                                        }
                                    />
                                    <Route path={'/conciliation/settlementVouchers'}
                                        element={
                                            WebCache.isFinancialAllowed() ? (
                                                <PaymentTransactionReport settlementNumber={undefined} show={true} />
                                            ) : (
                                                <Navigate
                                                    to="/sales/transactions"
                                                />
                                            )
                                        }
                                    />
                                    <Route path={'/conciliation/settlementTaxes'}
                                        element={
                                            WebCache.isFinancialAllowed() ? (
                                                <PaymentTaxReport />
                                            ) : (
                                                <Navigate
                                                    to="/sales/transactions"
                                                />
                                            )
                                        }
                                    />
                                    <Route path={'/conciliation/settlementConf'}
                                        element={
                                            WebCache.isManagementAllowed() ? (
                                                <SettlementConf />                                                                                            
                                            ) : (
                                                <Navigate
                                                    to="/sales/transactions"
                                                />
                                            )
                                        } />
                                    {/* Settlements */}
                                    <Route path={'/pdfsett/daily'}
                                        element={
                                            WebCache.isFinancialAllowed() ? (
                                                <SettlementsByDay />
                                            ) : (
                                                <Navigate
                                                    to="/dashboard"
                                                />
                                            )
                                        }
                                    />
                                    <Route path={'/pdfsett/monthly'}
                                        element={
                                            WebCache.isFinancialAllowed() ? (
                                                <SettlementsByMonth />
                                            ) : (
                                                <Navigate
                                                    to="/dashboard"
                                                />
                                            )
                                        }
                                    />
                                    <Route path={'/pdfsett/charge-backs'}
                                        element={
                                            WebCache.isFinancialAllowed() ? (
                                                <SettlementChargeBacks />
                                            ) : (
                                                <Navigate
                                                    to="/dashboard"
                                                />
                                            )
                                        }
                                    />
                                    {UtilService.isMobilePlatform() ? "": <>
                                    {/* Reports */}
                                    <Route path={'/reports/settlements'}
                                        element={
                                            WebCache.isFinancialAllowed() ? (
                                                <PaymentReport />
                                            ) : (
                                                <Navigate
                                                    to="/sales/transactions"
                                                />
                                            )
                                        }
                                    />
                                    <Route path={'/reports/presentations'}
                                        element={
                                            WebCache.isFinancialAllowed() ? (
                                                <PresentationReport />
                                            ) : (
                                                <Navigate
                                                    to="/sales/transactions"
                                                />
                                            )
                                        }
                                    />
                                    <Route path={'/reports/operationTable'}
                                        element={
                                            WebCache.isFinancialAllowed() ? (
                                                <OperationTableReport />
                                            ) : (
                                                <Navigate
                                                    to="/sales/transactions"
                                                />
                                            )
                                        }
                                    />
                                    <Route path={'/reports/presentationDownloads'}
                                        element={
                                            WebCache.isFinancialAllowed() ? (
                                                <PresentationDownloadsReport />
                                            ) : (
                                                <Navigate
                                                    to="/sales/transactions"
                                                />
                                            )
                                        }
                                    />
                                    <Route path={'/reports/sendProfileManagement'} element={WebCache.isManagementAllowed() ? (
                                        <SendProfileManagement />
                                    ) : (
                                        <Navigate
                                            to="/dashboard"
                                        />
                                    )} />
                                    {/* Commerce */}
                                    <Route path={'/commerce/data'} element={WebCache.isManagementAllowed() ? (
                                        <DataCommerce />
                                    ) : (
                                        <Navigate
                                            to="/dashboard"
                                        />
                                    )} /> 
                                    {/* Settings */}
                                    <Route path={'/settings/users'} element={WebCache.isManagementAllowed() ? (
                                        <UsersManagement />
                                    ) : (
                                        <Navigate
                                            to="/dashboard"
                                        />
                                    )} /> 
                                    </>}
                                    {/* Integrations */}
                                    <Route path={'/integrations/MPAssociate'} element={!WebCache.getMPConfiguration().initialized ? (
                                        <MercadoPagoPage />
                                    ) : (
                                        <Navigate
                                            to="/dashboard"
                                        />
                                    )} />
                                    {/* Loyalty */}
                                    <Route path={'/loyalty'} element={<Loyalty />} />
                                    <Route path={'/loyalty/clients'} element={<ClientReport />} />
                                    <Route path={'/loyalty/promos'} element={<LoyaltyPromotions />} />
                                    <Route path={'/loyalty/coupons'} element={<LoyaltyVirtualCoupons />} />
                                    <Route path={'/loyalty/summary'} element={<LoyaltyAccountReport />} />
                                    {/* Other routes */}
                                    <Route path={'/MPConfirm'} element={WebCache.isManagementAllowed() ? (
                                        <MercadoPagoPageConfirm />
                                    ) : (
                                        <Navigate
                                            to="/dashboard"
                                        />
                                    )} />
                                </Routes>
                            </div>
                        </div>
                    </LayoutProvider>
                </MessagesProvider>
            </div>
            {
                !WebCache.isPosnetAppUser() && 
                    <Footer isValid={isValid} />
            }
        </div>
        </React.Fragment>
    );
}

export default Home;
 